<template>
  <div style="display: flex">
    <div style="margin: 10px">
      <div style="font-weight: bold; margin-left: 5px">
        {{ $t("_selectionnez_un_site_") }} :
      </div>
      <div
        v-if="sizeMap === 'small-map'"
        style="
          border: 1px solid black;
          width: 220px;
          height: 193px;
          overflow-y: auto;
        "
      >
        <table style="width: 100%; border-collapse: collapse">
          <tbody>
            <tr
              v-for="(site, index) in takeselectsites()"
              :key="index"
              :class="{
                'highlighted-site': site.installation_name === sitecenter,
              }"
              style="
                border-bottom: 1px solid #ccc;
                cursor: pointer;
                width: 100%;
              "
              @click="centerMap(site.latitude, site.longitude)"
            >
              <td style="padding: 10px; font-size: 10px; width: 100%">
                {{ site.installation_name }}
              </td>
            </tr>
            <tr v-if="takeselectsites().length < 10">
              <td
                v-for="n in 10 - takeselectsites().length"
                :key="n"
                style="padding: 10px; font-size: 10px"
              ></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div
      :class="sizeMap"
      style="flex: 1; margin: 10px; border: 1px solid black"
    >
      <l-map
        ref="leafletMap"
        style="height: 100%; width: 100%"
        :zoom="zoom"
        :center="mapCenter"
        :options="{ attributionControl: false }"
        @moveend="updateSiteCenter"
      >
        <l-tile-layer
          v-for="tileProvider in tileProviders"
          :key="tileProvider.name"
          :name="tileProvider.name"
          :visible="tileProvider.visible"
          :url="tileProvider.url"
          layer-type="base"
        />
        <l-control-layers position="topright" style="margin: 20px">
        </l-control-layers>

        <l-control
          :visible="true"
          position="bottomleft"
          style="z-index: 10000; position: absolute; bottom: 0px"
        >
          <v-btn style="z-index: 10000" @click="resizeMap()">
            <v-icon> {{ buttonSymbole }} </v-icon>
          </v-btn>
        </l-control>

        <l-marker
          v-for="(site, index) in takeselectsites()"
          :key="index"
          :lat-lng="[site.latitude, site.longitude]"
          :icon="getIconForSite(site)"
        >
          <l-popup>
            <b>
              {{ site.installation_name }}
            </b>
            <br />
            {{ site.address }}
            <br />
            {{ site.postalCode }}
            <br />
            {{ site.country }}
            <br />
            {{ roundtwodec(site.pdc_max) }} kwc
            <br />
            <hr />
          </l-popup>
        </l-marker>
      </l-map>
    </div>
  </div>
</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { mapGetters } from "vuex";

export default {
  props: {
    selectsite: {
      type: Array,
      required: true,
    },
    liste_fleet: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      buttonSymbole: "mdi-arrow-bottom-left",
      zoom: 4,
      sitecenter: "",
      sizeMap: "small-map",
      mapCenter: [46.6034, 3.1237],
      defaultZoom: 15,
      tileProviders: [   
        {
          url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png",
          visible: true,
          name: "satelliteESRI",
          attribution:
            "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community",
        },

        {
          url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
          visible: true,
          name: "OpenTopoMap",
          attribution:
            'Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
        },
        {
          url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
          visible: true,
          name: "OpenStreetMap",
          attribution:
            '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        },
      ],
    };
  },

  computed: {
    ...mapGetters(["role", "cur_install_id", "constants", "installations"]),
  },

  watch: {
    zoom: {
      handler() {
        this.sitecenter = this.searchsite();
      },
    },
  },

  methods: {
    centerMap(lat, long) {
      const map = this.$refs.leafletMap.mapObject;
      map.setView([lat, long], 15);
    },
    resizeMap() {
      const map = this.$refs.leafletMap.mapObject;
      if (this.sizeMap === "full-screen-map") {
        this.sizeMap = "small-map";
        this.buttonSymbole = "mdi-arrow-bottom-left";
      } else {
        this.sizeMap = "full-screen-map";
        this.buttonSymbole = "mdi-arrow-top-right";
      }
      this.$nextTick(() => {
        map.invalidateSize();
      });
    },

    updateSiteCenter() {
      this.sitecenter = this.searchsite();
    },

    searchsite() {
      const map = this.$refs.leafletMap.mapObject;
      const center = map.getCenter();
      let centersite = "";

      this.takeselectsites().forEach((element) => {
        const isLatitudeClose =
          Math.abs(element.latitude - center.lat) < 0.0001;
        const isLongitudeClose =
          Math.abs(element.longitude - center.lng) < 0.0001;
        if (isLatitudeClose && isLongitudeClose) {
          centersite = element.installation_name;
          return;
        }
      });
      return centersite;
    },

    roundtwodec(nombre) {
      return Math.round(nombre * 100) / 100;
    },

    takeselectsites() {
      let sites = [];

      this.installations.forEach((element) => {
        let cleanName = element.installation_name.trim();
        if (this.selectsite.includes(cleanName)) {
          sites.push(element);
        }
      });
      return sites;
    },

    calculPR(item) {
      if (!this.liste_fleet || this.liste_fleet.length === 0) {
        return 10001;
      }
      let evo = 10001;
      this.liste_fleet.forEach((elm) => {
        if (elm.installation_id == item.installation_id) {
          // evo = elm.evolution_ip_clean;
          evo = elm.perf_score_parc;
        }
      });
      return evo;
    },

    getIconForSite(site) {
      let iconUrl;

      if (
        typeof site.installation_type === "string" &&
        site.installation_type.indexOf("Batiment agricole / Toiture") !== -1
      ) {
        if (this.calculPR(site) >= 0 && this.calculPR(site) <= 10000) {
          iconUrl = require("./ressources/BatAgriToitV.png");
        } else if (this.calculPR(site) < 0 && this.calculPR(site) >= -5) {
          iconUrl = require("./ressources/BatAgriToitO.png");
        } else if (this.calculPR(site) < -5) {
          iconUrl = require("./ressources/BatAgriToitR.png");
        } else {
          iconUrl = require("./ressources/BatAgriToitG.png");
        }
      } else if (
        typeof site.installation_type === "string" &&
        site.installation_type.indexOf("Centrale au sol") !== -1
      ) {
        if (this.calculPR(site) >= 0 && this.calculPR(site) <= 10000) {
          iconUrl = require("./ressources/SolV.png");
        } else if (this.calculPR(site) < 0 && this.calculPR(site) >= -5) {
          iconUrl = require("./ressources/SolO.png");
        } else if (this.calculPR(site) < -5) {
          iconUrl = require("./ressources/SolR.png");
        } else {
          iconUrl = require("./ressources/SolG.png");
        }
      } else if (
        typeof site.installation_type === "string" &&
        site.installation_type.indexOf("Batiment tertiaire / Toiture") !== -1
      ) {
        if (this.calculPR(site) >= 0 && this.calculPR(site) <= 10000) {
          iconUrl = require("./ressources/BatTertToitV.png");
        } else if (this.calculPR(site) < 0 && this.calculPR(site) >= -5) {
          iconUrl = require("./ressources/BatTertToitO.png");
        } else if (this.calculPR(site) < -5) {
          iconUrl = require("./ressources/BatTertToitR.png");
        } else {
          iconUrl = require("./ressources/BatTertToitG.png");
        }
      } else if (
        typeof site.installation_type === "string" &&
        site.installation_type.indexOf("Tertiaire") !== -1
      ) {
        if (this.calculPR(site) >= 0 && this.calculPR(site) <= 10000) {
          iconUrl = require("./ressources/BatTertToitV.png");
        } else if (this.calculPR(site) < 0 && this.calculPR(site) >= -5) {
          iconUrl = require("./ressources/BatTertToitO.png");
        } else if (this.calculPR(site) < -5) {
          iconUrl = require("./ressources/BatTertToitR.png");
        } else {
          iconUrl = require("./ressources/BatTertToitG.png");
        }
      } else if (
        typeof site.installation_type === "string" &&
        site.installation_type.indexOf("Batiment industriel / Toiture") !== -1
      ) {
        if (this.calculPR(site) >= 0 && this.calculPR(site) <= 10000) {
          iconUrl = require("./ressources/BatInduV.png");
        } else if (this.calculPR(site) < 0 && this.calculPR(site) >= -5) {
          iconUrl = require("./ressources/BatInduO.png");
        } else if (this.calculPR(site) < -5) {
          iconUrl = require("./ressources/BatInduR.png");
        } else {
          iconUrl = require("./ressources/BatInduG.png");
        }
      } else if (
        typeof site.installation_type === "string" &&
        site.installation_type.indexOf("Batiment agricole / Serre") !== -1
      ) {
        if (this.calculPR(site) >= 0 && this.calculPR(site) <= 10000) {
          iconUrl = require("./ressources/BatAgriSerreV.png");
        } else if (this.calculPR(site) < 0 && this.calculPR(site) >= -5) {
          iconUrl = require("./ressources/BatAgriSerreO.png");
        } else if (this.calculPR(site) < -5) {
          iconUrl = require("./ressources/BatAgriSerreR.png");
        } else {
          iconUrl = require("./ressources/BatAgriSerreG.png");
        }
      } else if (
        typeof site.installation_type === "string" &&
        site.installation_type.indexOf("Batiment résidentiel") !== -1
      ) {
        if (this.calculPR(site) >= 0 && this.calculPR(site) <= 10000) {
          iconUrl = require("./ressources/BatResidentielV.png");
        } else if (this.calculPR(site) < 0 && this.calculPR(site) >= -5) {
          iconUrl = require("./ressources/BatResidentielO.png");
        } else if (this.calculPR(site) < -5) {
          iconUrl = require("./ressources/BatResidentielR.png");
        } else {
          iconUrl = require("./ressources/BatResidentielG.png");
        }
      } else if (
        typeof site.installation_type === "string" &&
        site.installation_type.indexOf("Ombriere parking") !== -1
      ) {
        if (this.calculPR(site) >= 0 && this.calculPR(site) <= 10000) {
          iconUrl = require("./ressources/OmbParkV.png");
        } else if (this.calculPR(site) < 0 && this.calculPR(site) >= -5) {
          iconUrl = require("./ressources/OmbParkO.png");
        } else if (this.calculPR(site) < -5) {
          iconUrl = require("./ressources/OmbParkR.png");
        } else {
          iconUrl = require("./ressources/OmbParkG.png");
        }
      } else {
        if (this.calculPR(site) >= 0 && this.calculPR(site) <= 10000) {
          iconUrl = require("./ressources/DefaultV.png");
        } else if (this.calculPR(site) < 0 && this.calculPR(site) >= -5) {
          iconUrl = require("./ressources/DefaultO.png");
        } else if (this.calculPR(site) < -5) {
          iconUrl = require("./ressources/DefaultR.png");
        } else {
          iconUrl = require("./ressources/DefaultG.png");
        }
      }
      const IndustrielToitIcon = L.icon({
        iconUrl: iconUrl,
        iconSize: [20, 20],
        iconAnchor: [10, 20],
        popupAnchor: [-17, -50],
      });
      const SolIcon = L.icon({
        iconUrl: iconUrl,
        iconSize: [20, 20],
        iconAnchor: [10, 20],
        popupAnchor: [-17, -50],
      });
      const defaultIcon = L.icon({
        iconUrl: iconUrl,
        iconSize: [20, 20],
        iconAnchor: [10, 20],
        popupAnchor: [-17, -50],
      });
      const TertiaireToitIcon = L.icon({
        iconUrl: iconUrl,
        iconSize: [20, 20],
        iconAnchor: [10, 20],
        popupAnchor: [-17, -50],
      });
      const AgricoleToitIcon = L.icon({
        iconUrl: iconUrl,
        iconSize: [20, 20],
        iconAnchor: [10, 20],
        popupAnchor: [-17, -50],
      });
      const AgricoleSerreIcon = L.icon({
        iconUrl: iconUrl,
        iconSize: [20, 20],
        iconAnchor: [10, 20],
        popupAnchor: [-17, -50],
      });
      const ResidentielIcon = L.icon({
        iconUrl: iconUrl,
        iconSize: [20, 20],
        iconAnchor: [10, 20],
        popupAnchor: [-17, -50],
      });
      const OmbriereParkIcon = L.icon({
        iconUrl: iconUrl,
        iconSize: [20, 20],
        iconAnchor: [10, 20],
        popupAnchor: [-17, -50],
      });
      if (
        typeof site.installation_type === "string" &&
        site.installation_type.indexOf("Batiment agricole / Toiture") !== -1
      ) {
        return AgricoleToitIcon;
      } else if (
        typeof site.installation_type === "string" &&
        site.installation_type.indexOf("Centrale au sol") !== -1
      ) {
        return SolIcon;
      } else if (
        typeof site.installation_type === "string" &&
        site.installation_type.indexOf("Batiment tertiaire / Toiture") !== -1
      ) {
        return TertiaireToitIcon;
      } else if (
        typeof site.installation_type === "string" &&
        site.installation_type.indexOf("Tertiaire") !== -1
      ) {
        return TertiaireToitIcon;
      } else if (
        typeof site.installation_type === "string" &&
        site.installation_type.indexOf("Batiment industriel / Toiture") !== -1
      ) {
        return IndustrielToitIcon;
      } else if (
        typeof site.installation_type === "string" &&
        site.installation_type.indexOf("Batiment agricole / Serre") !== -1
      ) {
        return AgricoleSerreIcon;
      } else if (
        typeof site.installation_type === "string" &&
        site.installation_type.indexOf("Batiment résidentiel") !== -1
      ) {
        return ResidentielIcon;
      } else if (
        typeof site.installation_type === "string" &&
        site.installation_type.indexOf("Ombriere parking") !== -1
      ) {
        return OmbriereParkIcon;
      } else {
        return defaultIcon;
      }
    },
  },
};
</script>

<style>
.full-screen-map {
  height: 100vh;
  width: 100vw;
  position: fixed !important;
  top: 0px;
  left: 0px;
  z-index: 10;
}
.small-map {
  width: 100%;
  height: 217px;
  margin-top: 20px;
  z-index: 0;
}
.highlighted-site {
  background-color: #d3d3d3;
}
</style>
